
import { defineComponent, PropType } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  props: {
    Default: { default: '' },
    Type: { default: 'date', Type: String as PropType<DateType> }, // date, time, week, duration
    Res: { default: null, type: String },
    FixedWidth: { default: '', Type: String },
    MinWidth: { default: '1.6em', Type: String },
    Name: { default: '', Type: String },
    PreserveMemory: { default: false, Type: Boolean },
    DefaultReset: { default: false },
    HoursMax: { default: 24, type: Number },
    MinutesMax: { default: 59, type: Number }
  },
  emits: {
  },
  data () {
    return {
    }
  },
  mounted () {
    if (this.Default) this.MEMWrite(this.Res, this.Default.replace('.000000', ''))
    if (!this.MEMRead(this.Res)) this.MEMWrite(this.Res, '')
  },
  unmounted () {
    if (this.Res && !this.PreserveMemory) {
      this.MEMClean(this.Res)
    }
  },
  methods: {
    TimeFixer (minutes :any, max :number) {
      // // Ensure that the input is a number
      // minutes = parseInt(minutes, 10)

      // // Check if the value is a valid minute (between 0 and 59)
      // if (isNaN(minutes) || minutes < 0 || minutes > max) {
      //   return 'Invalid input'
      // }
      // Use the padStart method to ensure a minimum length of 2, adding a leading zero if necessary
      return minutes.toString().padStart(2, '0')
    }
  },
  computed: {
    CurrentValue () {
      return this.MEMRead(this.Res)
    },
    DuratioValue () {
      if (this.Type !== 'duration') return ''
      return (this.MEMRead(this.Res + '_hours') ? this.MEMRead(this.Res + '_hours').toString().padStart(2, '0') : '00') + ':' + (this.MEMRead(this.Res + '_minutes') ? this.MEMRead(this.Res + '_minutes').toString().padStart(2, '0') : '00')
    }
  },
  watch: {
    CurrentValue: function (newVal, oldVal) { // watch it
      if (this.MEMRead(this.Res)?.indexOf('.000000') > -1) {
        this.MEMWrite(this.Res, this.MEMRead(this.Res).replace('.000000', ''))
      }
    },
    DuratioValue () {
      if (this.Type === 'duration') {
        this.MEMWrite(this.Res, this.DuratioValue)
        this.$emit('changed', this.DuratioValue)
      }
    }
  }
})
